"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return TextArea;
    }
});
class TextArea {
    // Method to add the textarea to the document body
    add() {
        this.body.appendChild(this.textarea);
        this.focus();
    }
    // Method to remove the textarea from the document body
    remove() {
        if (this.textarea.parentNode) {
            this.textarea.parentNode.removeChild(this.textarea);
        }
    }
    // Method to set textarea attributes
    setAttributes(attributes = {}) {
        if (typeof attributes !== "object" || attributes === null) {
            console.error("Attributes must be an object");
            return;
        }
        // Merge new attributes with existing ones
        this.attributes = Object.assign(this.attributes, attributes);
        // Update textarea attributes
        Object.entries(attributes).forEach(([attr, value])=>{
            switch(attr){
                case "position":
                    Object.assign(this.textarea.style, {
                        top: `${this.padding + value.y}px`,
                        left: `${this.padding + value.x}px`
                    });
                    break;
                case "value":
                    this.textarea.textContent = value;
                    break;
                case "padding":
                    this.padding = value;
                    break;
                case "width":
                case "height":
                    const dimension = value - 2 * this.padding;
                    this.textarea.style[attr] = `${dimension}px`;
                    break;
                case "onChange":
                case "onKeyDown":
                    this.removeEventListener(attr.slice(2), this.attributes[attr]);
                    this.addEventListener(attr.slice(2), value);
                    break;
                default:
                    this.textarea.setAttribute(attr, value);
            }
        });
    }
    // Method to add event listener to the textarea
    addEventListener(eventType, listener) {
        this.textarea.addEventListener(eventType, listener);
    }
    // Method to remove event listener from the textarea
    removeEventListener(eventType, listener) {
        this.textarea.removeEventListener(eventType, listener);
    }
    // Method to focus on the textarea
    focus() {
        this.textarea.focus();
    }
    constructor({ value = "New Text", position = {
        x: 0,
        y: 0
    }, width = 100, height = 100, padding = 8, onChange = ()=>{}, onBlur = ()=>{}, onKeyDown = ()=>{} }){
        this.isFirefox = navigator.userAgent.toLowerCase().indexOf("firefox") > -1;
        this.padding = padding;
        this.widthPadded = width - 2 * padding;
        this.heightPadded = height - 2 * padding;
        this.body = document.body;
        this.attributes = {};
        // Create textarea element
        this.textarea = document.createElement("textarea");
        this.textarea.textContent = value;
        // Set textarea styles
        const { textarea } = this;
        textarea.style.cssText = `
      position: absolute;
      top: ${position.y}px;
      left: ${position.x}px;
      width: ${this.widthPadded}px;
      height: ${this.heightPadded}px;
      margin-top: ${this.isFirefox ? "0px" : "-2px"};
      border: none;
      padding: 0px;
      background: none;
      outline: none;
      resize: none;
      color: white;
      font-size: 14px;
      font-family: sans-serif;
    `;
        // Attach event listeners
        this.addEventListener("input", onChange);
        this.addEventListener("blur", onBlur);
        this.addEventListener("keydown", onKeyDown);
    }
}
